import CheckmateApiClient from '../../services/apiClient';
import { useQuery } from 'react-query';

const _apiClient = new CheckmateApiClient();

export const useGetExpertKey = 'get-user-setting';

export const useGetUserSetting = (userSettingType: number, enabled = true) => {
    return useQuery({
        queryKey: [useGetExpertKey, userSettingType],
        queryFn: async () => {
            const response = await _apiClient.getUserSettingByType(userSettingType);

            if (!response.httpResponse.ok) {
                throw new Error('Failed to get User Setting.');
            }

            return response.payload;
        },
        enabled: !!enabled,
    });
};
